import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import constants from "../../constants/tutorialAutomaton";
import { useUser } from "../../context/userContext";
import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHowToUse";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";
import { Button } from "@material-ui/core";
// const percent = "100%";

const useStyles = makeStyles(styles);

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//   },
//   paper: {
//     height: 300,
//     width: 200,
//     backgroundColor: "#dbdbdd",
//   },
//   control: {
//     padding: theme.spacing(2),
//   },
//   dialog: {
//     backgroundColor: "#ECECEC",
//   },
//   divNumber: {
//     backgroundColor: "#434359",
//     position: "absolute",
//     borderRadius: 10,
//     ...defaultFont,
//     border: 10,
//     margin: 5,
//     padding: 5,
//   },
//   divText: {
//     display: "flex",
//     justifyContent: "flex-start",
//     marginTop: 10,
//     marginLeft: 5,
//   },
//   divTitle: {
//     display: "flex",
//     justifyContent: "center",
//     fontWeight: "bold",
//   },
//   span: {
//     color: "black",
//     // ...defaultFont,
//     // fontFamily: "Roboto",
//   },
// }));

export default function TutorialAutomatonDialog() {
  const { language, isActiveTutorial, setActiveTutorial } = useUser();
  const [texts, setTexts] = useState([]);
  const [checked, setChecked] = useState(true);
  const [spacing] = React.useState(2);
  const classes = useStyles();

  useEffect(() => {
    setTexts([
      constants.tutorial.createState,
      constants.tutorial.createTransition,
      constants.tutorial.editState,
      constants.tutorial.editTransition,
    ]);
  }, []);

  const handleClose = () => {
    setActiveTutorial(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveTutorial}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.tutorial.howToUse[language]}
            <div className="wrapper-button-close">
              <Button
                onClick={handleClose}
                style={{ backgroundColor: "#999", color: "#FFF" }}
              >
                X
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Grid container className={classes.root} spacing={2}>
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={spacing}>
                {[0, 1, 2, 3].map((value, index) => (
                  <Grid key={value} item>
                    <Paper className={classes.paper} elevation={5}>
                      <div style={{ padding: 10 }}>
                        <div className="number-card">
                          <span className={classes.span}>{value}</span>
                        </div>
                      </div>
                      <div className={classes.divTitle}>
                        <span className={classes.title}>
                          {texts[index] != undefined
                            ? texts[index].title[language]
                            : ""}
                        </span>
                      </div>
                      {/* {value === 1 && (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <img style={{ width: 80 }} src={connect}></img>
                        </div>
                      )} */}
                      <div className={classes.divText}>
                        <span className={classes.text}>
                          {texts[index] != undefined
                            ? texts[index].text[language]
                            : ""}
                        </span>
                      </div>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
          {/* <DialogContentText id="alert-dialog-slide-description">
            {texts.map((text, index) => {
              return (
                <div key={index}>
                  {text[language]}
                  <br />
                  <br />
                </div>
              );
            })}
          </DialogContentText> */}
        </DialogContent>
        <DialogActions className={classes.dialog}>
          {constants.tutorial.dontShowAgain[language]}
          <Checkbox
            // checked={checked}
            // onChange={handleChange}
            color="primary"
            inputProps={{ "aria-label": "secondary checkbox" }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
